const template = require('./holdings_list.html.slim');
const controller = require('./holdings_list_controller');

angular
  .module('wbComponents')
  .directive('holdingsList', () =>
    ({
      replace: true,
      restrict: 'E',
      templateUrl: template,
      controller,
      controllerAs: 'ctrl',
    }),
);
